import React, { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import { HiArrowLeft } from 'react-icons/hi';
import { useNavigate } from "react-router-dom";
import Header from '../../Layout/Header';
import { useMediaQuery } from 'react-responsive';
import SidebarMenu from "../../Layout/SidebarMenu";
import TablePurchaseInvoice from "./TablePurchaseInvoice";
 import ListPurchaseInvoice from "./ListPurchaseInvoice";
// import PurchaseInvoice from "./MainIndex";


const PurchaseInvoice = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const navigate = useNavigate();

    useEffect(() => {

    }, []);

    return (
        <>
            <Helmet>
                <title>Data Pembayaran</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Data Pembayaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
                {isMobile && <ListPurchaseInvoice />}
            </div>
            <div className="d-none d-sm-inline">
                <Header />
                {isTabletOrLaptop && <TablePurchaseInvoice />}
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
        </>
    );
}

export default PurchaseInvoice;
